import React from 'react';
import ConversationTableCompleted from '../../../features/supervision/conversations/components/ConversationTable/Completed/ConversationTableCompleted';

function ConversationList() {
    return (
        <ConversationTableCompleted />
    );
}

export default ConversationList;
